export default "__VITE_ASSET__69887c20__"